
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
@Component({
  components: {},
})
export default class extends Vue {
  @Prop()
  modelValue: any;

  @Prop()
  disabledList: any;

  async chooseArea() {
    let data = await this.$chooseAddress({
      title: "请选择区域",
      selectList: this.modelValue,
      disabledList: this.disabledList || [],
    });
    this.$emit('update:modelValue', data);
  }
}
